import { Action } from '../../definitions/types';
import * as Actions from '../actions/actions-consts';
import { TEMPLATES_PER_PAGE } from '../../modules/constants';

export default function amountTemplates(
  state: number = TEMPLATES_PER_PAGE,
  action: Action<any> // tslint:disable-line no-any
): number {
  switch (action.type) {
    case Actions.INCREASE_AMOUNT_TEMPLATES:
      const increasedAmount = state + TEMPLATES_PER_PAGE;
      const maxLevelled = Math.ceil(action.payload / TEMPLATES_PER_PAGE);
      const currentLevelled = Math.ceil(increasedAmount / TEMPLATES_PER_PAGE);
      return currentLevelled <= maxLevelled ? increasedAmount : state;
    case Actions.RESET_AMOUNT_TEMPLATES:
      return TEMPLATES_PER_PAGE;
    default:
      return state;
  }
}
